import {Component} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faSquarePlus, faXmarkSquare} from '@fortawesome/free-solid-svg-icons';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {getUpdatedFieldsFormData} from '../../common/utils';


@Component({
    selector: 'app-edit-vehicle-database',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './edit-vehicle-database.component.html',
    styleUrl: './edit-vehicle-database.component.css'
})
export class EditVehicleDatabaseComponent {
  updateVehicleForm: FormGroup;
  errorMessage: []  = [];
  vehicleData: any;
  vehicleChoice: any  = [
                    '',
                    'CAR',
                    'VAN',
                    'BIKE',
                    'BUS',
                    'AUTO'
                  ];
  
  // contryCode: any  = [
  //                    "+91",
  //                   //  "+1",
  //                   //  "+44",
  //                   //  "+123" 
  //                     ];

  fieldMapping:any = {
    "empId": "employee_id",
    "vehicleNo": "vehicle_number",
    "vehicleType": "vehicle_type",
    "personName": "person_name",
    "mobileNo": "mobile_number",
    "comments": "comments",
  }
                    
                  
  constructor(private apiService: ApiService, 
              private router: Router,
              private toastr:ToastrService,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              library: FaIconLibrary,
              ) {
    library.addIcons(faXmarkSquare, faSquarePlus)
    
    this.updateVehicleForm = fb.group({
      empId: ['', [
                    Validators.required, 
                    Validators.minLength(3),
                    Validators.maxLength(10),
                  ]],
      vehicleNo: ['', Validators.required],
      vehicleType: ['CAR', Validators.required],
      // countryCode: ['+91', Validators.required],
      mobileNo: ['', [
                      Validators.required, 
                      Validators.pattern('^[0-9]{10}$')
                    ]
                ],
      personName: ['', Validators.required],
      comments: ['']

    });
  }
  ngOnInit(): void {
    let pk = this.route.snapshot.paramMap.get('pk');
    this.getVehicle(pk);
}
  getVehicle(pk:any){
    this.apiService.getVehicle(pk).subscribe({
      next: (res:any) => {
        this.updateVehicleForm = this.fb.group({
          empId: [res['employee_id'],[
                  Validators.required, 
                  Validators.minLength(3),
                  Validators.maxLength(10),
          ]],
          vehicleNo:[res['vehicle_number'], Validators.required],
          vehicleType: [res['vehicle_type'].toUpperCase(), Validators.required],
          mobileNo: [res['mobile_number'], [Validators.required,
                                            Validators.pattern('^([+-]{0,1}[ ]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[ ]{0,1}){0,4}$')
          ]],
          personName: [res['person_name'], Validators.required],
          comments: res['comments'],
      })
    },
    error: (err) =>{
      
    }
    })

  }
  onSubmit() {
    if (this.updateVehicleForm.valid) {
      let updatedFields = getUpdatedFieldsFormData(this.updateVehicleForm, this.fieldMapping);
      let veh_type = updatedFields.get('vehicle_type')
      if (veh_type) {
        updatedFields.set('vehicle_type',  veh_type.toString().toLowerCase())
      }
      let pk:any = this.route.snapshot.paramMap.get('pk');
      this.apiService.updateVehicle(pk, updatedFields).subscribe({
          next: (response:any) => {
            this.toastr.success("Vehicle Updated successfully.", 'Success');
            this.router.navigate(['/vehicle']);
          },
          error: (err) => {
            if (err['error']['non_field_errors']) {
              err['error']['non_field_errors'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['error']['vehicle_number']) {
              err['error']['vehicle_number'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['error']['mobile_number']) {
              err['error']['mobile_number'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['error']['person_name']) {
              err['error']['person_name'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }else if (err['error']['employee_id']) {
              err['error']['employee_id'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }else if (err['error']['vehicle_type']) {
              err['error']['vehicle_type'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }  else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error("Something went wrong!", 'Error');
            }
          }
        }
      )
    } else {
      this.validateAllFormFields(this.updateVehicleForm);
    }
  }
  validateAllFormFields(formGroup: FormGroup) {   
    Object.keys(formGroup.controls).forEach(field => {  
      const control = formGroup.get(field);             
      if (control instanceof FormGroup) {        
        this.validateAllFormFields(control);            
      } else {                                      
        control?.markAsTouched({ onlySelf: true });
      }
    });
  }

  onCancel() {
    // Handle cancel action

    this.router.navigate(['/vehicle']);
  }

}
